// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nJGtS","hover":"styles_hover__I0Z8Q","angle-right":"styles_angle-right__PsTQ6","angleRight":"styles_angle-right__PsTQ6"};